import React, { useState } from "react";

import { ChildCommentProps } from "@/features/comment/type";
import { useUserContext } from "@/features/user/contexts/useUserContext";

import { CommentAvatar, CommentContent, CommentName, CommentTime } from ".";
import { CommentRemoveButton } from "./CommentRemoveButton";

export const ChildComment: React.FC<ChildCommentProps> = (props) => {
  const { comment, isPostOwner } = props;
  const [replying, setReplying] = useState(false);
  const { user: me } = useUserContext();
  const { user, content, updatedAt, _id } = comment;
  const commentWriter = user._id === me?._id;
  const { avatar, displayName, accountName } = user;

  const onClickReply = () => {
    setReplying(true);
  };

  return (
    <div className="flex w-full py-2 space-x-3.5">
      {/* Left Column */}
      {/* Avatar */}
      <CommentAvatar
        avatarUrl={avatar?.url}
        displayName={displayName}
        accountName={accountName}
      />

      {/* Right Column */}
      <div className="flex flex-col flex-1 min-w-0">
        {/* Name, Time, RepliesCount*/}
        <div className="flex items-center space-x-2 min-w-0">
          <CommentName displayName={displayName} accountName={accountName} />

          <CommentTime time={new Date(updatedAt)} />
        </div>
        {/* Content */}
        <CommentContent content={content} />

        <div className="flex items-center space-x-4 ">
          {/* Remove Comment Button */}
          <CommentRemoveButton
            commentId={_id}
            isPostOwner={isPostOwner || commentWriter}
          />
        </div>

        {/* TODO: reply to child comment*/}
        {/* <CommentReplyButton onClick={onClickReply} /> */}
        {/* {replying && <div>Implementing...</div>} */}
      </div>
    </div>
  );
};
